<template>
  <div>
    <custom-actions show-back :title="title">
      <el-form class="form" :model="formData" :rules="rules" ref="formData" label-width="140px">
        <el-form-item label="账号" prop="userId">
          <el-select filterable clearable v-model="formData.userId" :disabled="userId !== ''" placeholder="请选择账号">
            <el-option v-for="(item, index) of userList" :value="item.userId" :label="item.userName"
                       :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="采购方" prop="payerList">
          <el-select filterable clearable multiple v-model="formData.payerList" placeholder="请选择采购方">
            <el-option v-for="(item, index) of userList1" :value="item.userId" :label="item.userName"
                       :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submit" class="global-button">保存</el-button>
          <el-button @click="$router.back()" class="global-button">取消</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

  </div>
</template>

<script>
export default {
  components: {
  },
  name: 'UserPayerAdd',
  data() {
    return {
      userList: [],
      userList1: [],
      formData: {
        userId: '', // 账号
        payerList: []
      },
      rules: {
        userId: [{ required: true, message: '请选择账号', trigger: 'change' }],
        payerList: [{ required: true, message: '请选择采购方', trigger: 'change' }]
      }
    }
  },
  computed: {
    userId() {
      return this.$route.query.userId || ''
    }
  },
  created() {
    this.loadUser()
    this.loadUser1()
    if (this.userId) {
      this.loadDetails()
    }
  },
  methods: {
    loadUser() {
      this.$axios.get(this.$apis.patrolProblemReport.selectIparkUserByRole, {
        userType: '1'
      }).then(res => {
        this.userList = res || []
      })
    },
    loadUser1() {
      this.$axios.get(this.$apis.patrolProblemReport.selectIparkUserByRole, {
        userType: '2,3'
      }).then(res => {
        this.userList1 = res || []
      })
    },
    loadDetails() {
      this.$axios.get(this.$apis.yxcUserPayer.selectYxcUserPayerByUserId, {
        userId: this.userId
      }).then(res => {
        this.formData = {
          userId: res.userId || '',
          payerList: res.payerList || []
        }
      })
    },
    submit() {
      this.$refs.formData.validate().then(() => {
        const url = this.userId ? this.$apis.yxcUserPayer.updateYxcUserPayer : this.$apis.yxcUserPayer.insertYxcUserPayer
        this.$axios.post(url, this.formData).then(res => {
          this.$router.back()
        })
      })
    }

  }
}
</script>

<style scoped lang='scss'>
.el-select,
.el-input,
.el-cascader {
  width: 400px;
}
</style>
